<div class="flex flex-col lg:flex-row h-full">
  <div class="sidebar">
    <button *ngIf="hasBackButton" type="button" class="button-primary" mat-flat-button (click)="goBack()">
      <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
      <span>{{ 'Back' }}</span>
    </button>
  </div>
  <div class="content-main">
    <div class="content-main-wrapper backdrop-color" *ngIf="current === 'imprint'">
      <h1 class="title text-[64px] leading-tight">
        <b>Imprint</b>
      </h1>
      <br />
      <div class="static">
        <p>
          <strong>{{ imprint.company.name }}</strong>
        </p>
        <p>
          <strong>Address:</strong>
          <br />
          {{ imprint.address.street }} <br />{{ imprint.address.zipCode }} {{ imprint.address.city }}<br />{{ imprint.address.country }}
        </p>
        <p>
          <strong>Contact:</strong><br />
          Telephone: {{ imprint.telephone }}<br />
          Telefax: {{ imprint.telefax }}<br />
          E-Mail: {{ imprint.email.contact }}
        </p>
        <p>
          USt-IdNr./VAT Nr. according to § 27 a Value Added Tax Act: {{ imprint.company.id }},<br />
          District court {{ imprint.company.districtCourt }}
        </p>
        <p>
          <strong>Authorised executive:</strong><br />
          {{ imprint.authorizedExecutive }}
        </p>
        <p>
          <strong>Disclaimer:</strong><br />
          Despite careful content monitoring, we cannot accept any liability for the content of external links. Responsibility for the content of linked sites lies exclusively with their operators.
        </p>
      </div>
    </div>

    <div class="content-main-wrapper backdrop-color" *ngIf="current === 'privacy'">
      <h1 class="title text-[64px] leading-tight">
        <b>Privacy</b>
      </h1>
      <br />
      <div class="static">
        <p>
          This is information for your relating to the handling of your personal data when you visit our website. To provide the functions and services of our website, it is required that we collect
          your personal data. In the following, we explain you which of your data we collect, the purpose of the collection, and which rights you have in relation to your data.
        </p>
        <p>The entity responsible for the processing of personal data on this website is:</p>
        <p><strong>Serviceplan Make GmbH & Co. KG</strong><br />Friedenstrasse 24 <br />81671 München</p>
        <p>
          <strong>Contact:</strong><br />
          Telefon: +49 89 2050 4300<br />
          Telefax: +49 89 2050 60 4300<br />
          E-Mail: info(at)house-of-communication.com
        </p>
        <p>
          You may as well ask our data protection officer questions on data privacy at any time at
          <a href="mailto:privacy@serviceplan.com">privacy&#64;serviceplan.com</a>.
        </p>
        <p>&nbsp;</p>
        <p><strong>Use for Information Purposes</strong></p>
        <p>
          If you use the website without transmitting any other data to us (e.g. by registration or use of the contact form), we will only collect the technically required data, which are transmitted
          automatically to our server (e.g. IP address, date and time of the request, browser type and operating system). This is a technical requirement to allow us showing you our website. If
          personal data are affected in this context, Art. 6(1)(f) GDPR is the legal basis for the collection.
        </p>
        <p>&nbsp;</p>
        <p><strong>Use of Cookies</strong></p>
        <p>
          We use cookies to facilitate and improve the use of our website. Cookies are text information stored via the web browser on a computer at the visit of a website. The purpose is to recognize
          a visit, e.g. in case of a permanent login to a website or for the shopping cart function of an online shop.
        </p>
        <p>
          Most of the web browsers accept cookies automatically. You may erase stored cookies at any time via the settings of your web browser. You may also adjust the settings of your web browser to
          bar the storing of cookies. Then, however, not all the functions of our website might be available.
        </p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>Contact Form</strong></p>
        <p>
          On our website, you may use a contact form to enter personal data. If you use the contact form, we collect and store the data you enter in the input screen (e.g. second name, first name,
          email address). There will be no forwarding to any third parties.
        </p>
        <p>
          If consent is given, the legal basis for the processing is Art. 6(1)(a) GDPR. If your request has the purpose of preparing the signing of a contract, Art. 6(1)(b) GDPR is an additional legal
          basis. We use the data to process and answer your request only.
        </p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>Application Option</strong></p>
        <p>
          You may file your application on our website. If you apply, we collect and store the data you enter in the input screen. There will be no forwarding. The use of the application function is
          possible with your consent only. The legal basis for the processing is Art. 6(1)(a) GDPR. The exclusive purpose of the collection of the application data is to process your application.
        </p>
        <p>&nbsp;</p>
        <p><strong>Newsletter</strong></p>
        <p>
          On our website, you can subscribe to a newsletter. If you subscribe to the newsletter, we collect and store the data you enter in the input screen (e.g. second name, first name, email
          address). There will be no forwarding to any third parties. The subscription to the newsletter is possible with your consent only. The legal basis for the processing is Art. 6(1)(a) GDPR. We
          use the data only for sending newsletters.
        </p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>Storing Period</strong></p>
        <p>
          We process and store your data only for as long as it is required for the processing or for complying with statutory duties. Once the purpose of processing no longer exists, your data will
          be blocked or erased. If there are any additional statutory duties to store the data, we block or erase your data upon the lapse of the statutory storing periods.
        </p>
        <p><strong>&nbsp;</strong></p>
        <p><strong>Your Rights</strong></p>
        <p>You have the following statutory rights against us relating to your personal data:</p>
        <ol>
          <li>
            Right to be informed<br />As the data subject (affected person), you have the right to request a confirmation on whether we process personal data relating to you. If this is the case, you
            have the right to be informed of such personal data as well as to further information, e.g. the purpose of processing, the recipient and the scheduled storing period or the criteria for
            the determination of such period, respectively.
          </li>
          <li>
            Right to rectification and completion<br />As the data subject, you have the right to request the immediate rectification of incorrect data. Taking into consideration the purpose of
            processing, you have the right to request the completion of incomplete data.
          </li>
          <li>
            Right to erasure (“right to be forgotten”)<br />As the data subject, you have the right to erasure if processing is not necessary. This is the case e.g. if your data are no longer required
            for the original purposes, if you withdrew your statement of consent relating to data privacy, or if the data have been processed unlawfully.
          </li>
          <li>Right to restriction of processing<br />As the data subject, you also have the right to restriction of the processing if e.g. you think that the personal data would be incorrect.</li>
          <li>Right to data portability<br />As the data subject, you have the right to receive your personal data in a structured, customary and machine-readable format.</li>
          <li>
            Right to object<br />As the data subject, you have the right to raise objection against the processing of certain of your personal data at any time for reasons resulting from your
            situation.<br />In case of direct marketing, you as the data subject have the right to raise objection against the processing of your personal data for the purpose of such marketing at any
            time; this also applies to the profiling associated with such direct marketing.
          </li>
          <li>
            Right to withdraw your consent relating to data privacy<br />You may withdraw a consent to the processing of your personal data with effect in the future at any time. The legality of the
            processing made until such withdrawal, however, is not affected by the foregoing.
          </li>
        </ol>
        <p>Moreover, you may lodge complaint with a data protection supervisory authority if you feel that the data processing does not comply with data protection regulations.</p>
      </div>
    </div>

    <div class="content-main-wrapper backdrop-color" *ngIf="current === 'support'">
      <h1 class="title text-[64px] leading-tight">
        <b>Support</b>
      </h1>
      <br />
      <div class="static">
        <p>If you have any Support questions please contact {{ imprint.email.support }}</p>
      </div>
    </div>
    <div class="app-footer-container">
      <div class="footer-content">
        <sp-footer></sp-footer>
      </div>
    </div>
  </div>
</div>
